import Center from "../components/core/Center/Center";
import Icon from "../components/core/Icon/Icon";
import styles from "./Footer.module.scss";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <Center className={styles.inner}>
        <div>
          <div>
            Ein Projekt der Gemeinden St. Martin und St. Leonhard in Passeier
          </div>
          <div>
            <a
              href="mailto:chronik@passeier.it"
              target="_blank"
              rel="noreferrer"
            >
              chronik@passeier.it
            </a>
          </div>
          <div>&copy; 2025</div>
        </div>
        <div className={styles.logosWrapper}>
          <a href="https://www.stmp.it" target="_blank" rel="noreferrer">
            <Icon icon="stmartin" width={25} height={25} />
          </a>
          <a
            href="https://www.sankt-leonhard.eu"
            target="_blank"
            rel="noreferrer"
          >
            <Icon icon="stleonhard" width={25} height={25} />
          </a>
          {/* <a
            href="https://www.gemeinde.moosinpasseier.bz.it"
            target="_blank"
            rel="noreferrer"
          >
            <Icon icon="moos" width={25} height={25} />
          </a> */}
        </div>
        <div></div>
      </Center>
    </footer>
  );
};

export default Footer;
